import { PAYTM_MINIAPP_INITIATE_TRANSACTION, PAYTM_MINIAPP_STATUS_CHECK, PHONEPE_SWITCH_INITIATE_TRANSACTION, PHONEPE_SWITCH_STATUS_CHECK, MINIAPP_PAYMENT_STATUS_RESET, PAYTM_MINIAPP_STATUS_CHECK_SUCCESS, PAYTM_MINIAPP_STATUS_CHECK_FAILURE, PHONEPE_SWITCH_STATUS_CHECK_SUCCESS, PHONEPE_SWITCH_STATUS_CHECK_FAILURE, PAYTM_MINIAPP_INITIATE_TRANSACTION_SUCCESS, PAYTM_MINIAPP_INITIATE_TRANSACTION_FAILURE, PHONEPE_SWITCH_INITIATE_TRANSACTION_SUCCESS, PHONEPE_SWITCH_INITIATE_TRANSACTION_FAILURE, } from '../../constants';
export const initiatePaytmMiniAppTransaction = (payload) => ({
    type: PAYTM_MINIAPP_INITIATE_TRANSACTION,
    payload,
});
export const initiatePaytmMiniAppTransactionSuccess = (response) => ({
    type: PAYTM_MINIAPP_INITIATE_TRANSACTION_SUCCESS,
    response,
});
export const initiatePaytmMiniAppTransactionFailure = () => ({
    type: PAYTM_MINIAPP_INITIATE_TRANSACTION_FAILURE,
});
export const checkPaytmMiniAppPaymentStatus = (payload, paytmMaxRepeatCallsCount) => ({
    type: PAYTM_MINIAPP_STATUS_CHECK,
    payload,
    paytmMaxRepeatCallsCount,
});
export const paytmMiniAppPaymentStatusSuccess = (response) => ({
    type: PAYTM_MINIAPP_STATUS_CHECK_SUCCESS,
    response,
});
export const paytmMiniAppPaymentStatusFailure = (response) => ({
    type: PAYTM_MINIAPP_STATUS_CHECK_FAILURE,
    response,
});
export const initiatePhonepeSwitchTransaction = (payload) => ({
    type: PHONEPE_SWITCH_INITIATE_TRANSACTION,
    payload,
});
export const initiatePhonepeSwitchTransactionSuccess = (response) => ({
    type: PHONEPE_SWITCH_INITIATE_TRANSACTION_SUCCESS,
    response,
});
export const initiatePhonepeSwitchTransactionFailure = () => ({
    type: PHONEPE_SWITCH_INITIATE_TRANSACTION_FAILURE,
});
export const checkPhonepeSwitchPaymentStatus = (payload, phonepeMaxRepeatCallsCount) => ({
    type: PHONEPE_SWITCH_STATUS_CHECK,
    payload,
    phonepeMaxRepeatCallsCount,
});
export const phonepeSwitchPaymentStatusSuccess = (response) => ({
    type: PHONEPE_SWITCH_STATUS_CHECK_SUCCESS,
    response,
});
export const phonepeSwitchPaymentStatusFailure = (response) => ({
    type: PHONEPE_SWITCH_STATUS_CHECK_FAILURE,
    response,
});
export const resetMiniAppPaymentReducer = () => ({
    type: MINIAPP_PAYMENT_STATUS_RESET,
});
